export type AutosaveFlusher = () => void | Promise<void>;

import { registerSessionCleanup } from '../auth/sessionCleanup';

type AutosaveRegistration = {
  flush: AutosaveFlusher;
};

const registry = new Set<AutosaveRegistration>();

export function clearAutosaveRegistry(): void {
  registry.clear();
}

registerSessionCleanup(clearAutosaveRegistry);

export function registerAutosaveHandler(flush: AutosaveFlusher): () => void {
  const registration = { flush };
  registry.add(registration);
  return () => {
    registry.delete(registration);
  };
}

export async function flushAutosaves(): Promise<void> {
  if (registry.size === 0) return;
  const pending = Array.from(registry).map(({ flush }) => {
    try {
      const result = flush();
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  });
  const settled = await Promise.allSettled(pending);
  const failure = settled.find((item): item is PromiseRejectedResult => item.status === 'rejected');
  if (failure) {
    // Preserve structured validation/permission details for the shared UI translator.
    throw failure.reason;
  }
}
